import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SetupService } from '@core/services/setup';
import { VideosService } from './videos.service';

@Component({
    selector: 'app-videos',
    templateUrl: './videos.component.html',
    styleUrls: ['./videos.component.scss'],
})
export class VideosComponent implements OnInit {
    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[] = [];
    filters: any[] = [];
    loadAll = 1;

    /* Paginação */
    perPage: number = 6;
    page: number = 1;

    constructor(private videosService: VideosService, private title: Title, private setupService: SetupService) {}

    ngOnInit(): void {
        this.lastVideos();
        this.title.setTitle(`Vídeos - ${this.setupService.title}`);
    }

    /**
     * lastVideos() - Buscar últimos vídeos publicados
     */
    lastVideos(filters?) {
        this.videosService.getFilterVideos(filters).subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    onPageChange(pageNumber) {
        this.page = pageNumber;
    }
    /**
     * onFilterChange(): Ao mudar parãmetro de filtro
     * @param event Objeto com parâmetros selecionados/alterado através do filtro
     */
    onFilterChange(event) {
        this.lastVideos(event);
        this.loadAll = event.loadAll;
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = this.loadAll ? response.registers?.list : this.registers;
        this.filters = response.registers?.filters;
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
    }
}
